import React from 'react';
import '../css/TermsConditions.css';

const Termcondition = () => {
  return (
    <div>
<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
        <h1>Terms & Conditions</h1>
    </div>
  </div>
</section>

     

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            {/* Text Content Column */}
            <div className="col-12 col-md-8">
              <div className="terms-content">
                <h3 className='darkcolor'>Terms and Conditions</h3>
                <p>This document outlines the terms and conditions ("Terms") applicable to the use of the Woodland Escape  website ("Website"). By accessing or using this Website, you agree to comply with and be bound by these Terms.</p>

                <h4 className='darkcolor'>Website Information</h4>
                <p>All content provided on the Website is for informational purposes only and is owned by Woodland Escape . We strive to keep information accurate and up to date, but we do not guarantee the completeness or accuracy of any information presented. Woodland Escape  reserves the right to update or modify any content on the Website at any time without prior notice.</p>

                <h4 className='darkcolor'>Ownership and Location</h4>
                <p>Woodland Escape  is owned and operated by Woodland Escape Pvt. Ltd., located at:</p>
                <p><i>Forest Avenue,<br />
                  Woodland Escape , Wadamba, Behind St. Peters School, Deolapar, <br />
                  Dist. Nagpur - 441401</i></p>

                <h4 className='darkcolor'>User Eligibility</h4>
                <p>Users must be legally capable of entering into binding contracts under applicable law. Individuals under the age of 18 are not permitted to register or use the Website. Woodland Escape  reserves the right to restrict or terminate access for any user who violates these eligibility requirements or Terms.</p>

                <h4 className='darkcolor'>User Responsibilities</h4>
                <p>Users agree to provide accurate, current, and complete information when using the Website. You are responsible for maintaining the confidentiality of your account information and password, and for all activities that occur under your account.</p>

                <h4 className='darkcolor'>No Warranty</h4>
                <p>Woodland Escape does not warrant that the Website will be uninterrupted or error-free, nor that the Website or server are free of viruses or harmful components.</p>

                <h4 className='darkcolor'>Communication Consent</h4>
                <p>By using the Website, you consent to receive electronic communications from Woodland Escape , including emails, notices, and updates related to your use of the Website or services.</p>

                <h4 className='darkcolor'>Acceptable Use</h4>
                <p>You agree not to use the Website for any unlawful, harmful, or offensive purpose, including but not limited to:</p>
                <ul>
                  <li>Violating any laws or third-party rights.</li>
                  <li>Transmitting harmful or malicious content.</li>
                  <li>Engaging in unauthorized commercial activities.</li>
                  <li>Interfering with Website security or functionality.</li>
                </ul>

                <h4 className='darkcolor'>Intellectual Property</h4>
                <p>All content on the Website, including text, images, logos, and graphics, is the intellectual property of Woodland Escape  or its licensors. Unauthorized use or reproduction is prohibited without prior written consent.</p>

                <h4 className='darkcolor'>Third-Party Links</h4>
                <p>The Website may contain links to third-party websites. Woodland Escape is not responsible for the content or practices of such external sites and does not endorse them.</p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2 className='darkcolor'>Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us:</p>
            <ul>
              <li><b className='darkcolor'>Phone:</b> <a href="tel:+919175577266">+91 9175577266</a></li>
              <li><b className='darkcolor'>Email:</b> <a href="mailto:woodlandescape01@gmail.com">woodlandescape01@gmail.com</a></li>
            </ul>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Termcondition;


